module.exports = __webpack_public_path__ + "static/media/install.af590c16.png";